import * as types from '../../types'
import {
    API_URL
} from '../../utils/constants'
import {
    displayMessages,
    setSavingState
} from '../Layout/actions'
import {
    createAxiosInstance,
    validateModel
} from '../../utils/helpers'
import {
    tableActions
} from '@mawesi-sas/mws_react_component_table';
import FileDownload from 'react-file-download';

export function reiniciarEstado() {
    return (dispatch) => {
        dispatch({
            type: types.REPORTE1_REINICIAR_ESTADO
        })
    }
}

export function getDataFromServer(page = 1, excel = false) {
    const axios = createAxiosInstance()
    return (dispatch, getState) => {
        const modelo = 'Solicitud'
        const include = ['solicitante', 'detalles', 'distribuciones.cenco.aprobador']
        const take = 100
        const filter = getState().reporte1.getIn(['filter'])
        const fields = ['id', 'motivo', 'evento_actividad', 'nombre_cafeteria', 'fecha_hora', 'lugar', 'estado', 'solicitante.name', 'distribuciones.cenco.codigo']
        const filters = [{
            group: {
                id: 0,
                glue: 'and'
            },
            field: 'estado',
            operator: '=',
            value: 'COMPLETADA'
        }]

        if (filter) {
            fields.forEach(x => {
                let f = {
                    group: {
                        id: 1,
                        glue: 'and'
                    },
                    field: x,
                    operator: 'like',
                    value: filter
                }
                filters.push(f)
            })
        }
        const skip = (page - 1) * take
        const flag_procesadas = getState().reporte1.getIn('modalEditStatus.data.modify'.split('.')) || false
        const data = {
            modelo,
            filters,
            include,
            skip,
            take,
            orderBy: {
                field: 'id',
                direction: 'desc'
            },
            total: true,
            excel,
            flag_procesadas
        }
        if (excel) {
            axios.get(`${API_URL}/reportes/solicitudes-aprobadas`, {
                    params: data,
                    responseType: 'arraybuffer'
                })
                .then((res) => {
                    console.log(res)
                    FileDownload(res.data, 'Solicitudes aprobadas.xlsx');
                    dispatch(showHideModalEditStatus(false))
                })
                .catch((err) => {
                    let obj
                    if (err.response && err.response.data) {
                        const {
                            data,
                            status
                        } = err.response;
                        const decodedString = JSON.parse(String.fromCharCode.apply(null, new Uint8Array(data)));
                        obj = {
                            response: {
                                data: decodedString,
                                status
                            }
                        };
                    } else {
                        obj = err
                    }
                    console.log(err)
                    displayMessages(dispatch, obj);
                })
        } else {
            axios.post(`${API_URL}/reportes/solicitudes-aprobadas`, data)
                .then((res) => {
                    const list = res.data.data.map(x => {
                        x._enabled = true
                        return x
                    })
                    const records = res.data.total
                    dispatch(tableActions.mswTable_mostrarDatos('reporte1', 'reporte1', list, page, records))
                })
                .catch((err) => {
                    console.log(err)
                    displayMessages(dispatch, err)
                })
        }
    }
}

export function showHideModalEditStatus(show) {
    return (dispatch) => {
        dispatch({
            type: types.REPORTE1_MOSTRAR_MODAL_MODICAR_ESTADO_SOLICITUDES,
            payload: {
                show
            }
        })
    }
}